"use client";

import { useState, type FC, type Ref } from "react";
import { Turnstile, type TurnstileInstance } from "@marsidev/react-turnstile";
import type { TurnstileAction } from "cmw-client";

const TURNSTILE_SITE_KEY = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY ?? "";
// The backend skips verification in development too.
export const IS_TURNSTILE_DISABLED = process.env.NODE_ENV === "development";

type TurnstileWidgetProps = {
  ref: Ref<TurnstileInstance | undefined>;
  action: TurnstileAction;
};

export type { TurnstileInstance };

export const TurnstileWidget: FC<TurnstileWidgetProps> = ({ ref, action }) => {
  const [isShown, setIsShown] = useState(false);
  const show = () => setIsShown(true);

  if (IS_TURNSTILE_DISABLED) return null;

  return (
    <Turnstile
      ref={ref}
      id={`turnstile-${action}`}
      siteKey={TURNSTILE_SITE_KEY}
      options={{ action, appearance: "interaction-only", theme: "light" }}
      // Out of the flow until Cloudflare shows something, so the empty widget adds no layout gap.
      className={isShown ? undefined : "absolute"}
      onBeforeInteractive={show}
      onError={show}
      onUnsupported={show}
    />
  );
};
